import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const weekPlan = api(async function plan({
    prefix,
    group,
    startDate,
    windowStart,
    windowEnd,
    configuration,
    minimumIntervalInHours = 24 * 7,
    search,
}) {
    return query(
        gql`
            query Plan(
                $prefix: String!
                $group: String
                $startDate: Date
                $endDate: Date
                $windowEnd: Date
                $windowStart: Date
                $configuration: [SkillConfig]
                $minimumIntervalInHours: Int
                $search: String
                $useWeeks: Boolean
            ) {
                plan(
                    prefix: $prefix
                    group: $group
                    startDate: $startDate
                    endDate: $endDate
                    windowStart: $windowStart
                    windowEnd: $windowEnd
                    configuration: $configuration
                    minimumIntervalInHours: $minimumIntervalInHours
                    search: $search
                    useWeeks: $useWeeks
                ) {
                    days {
                        date
                        tasks {
                            skillCode
                            skillSet
                            classification
                        }
                        schedules {
                            red
                            green
                            amber
                            pink
                            fullPath
                            where
                            schedule {
                                id
                                _id
                                version
                                title
                                code
                            }
                            scheduleId
                            minutes
                            visits {
                                label
                            }
                            tasks {
                                id
                                minutes
                                assetIndex
                                assetId
                                intervalInHours
                                skillCode
                                task {
                                    id
                                    frequency {
                                        interval
                                        period
                                    }
                                }
                                skill
                                classification
                                title
                            }
                        }
                    }
                }
            }
        `,
        {
            prefix,
            startDate,
            endDate: new Date(Date.create(startDate)).addYears(30),
            windowEnd,
            windowStart,
            group,
            configuration,
            minimumIntervalInHours: Math.max(25, +minimumIntervalInHours - 1),
            search,
            useWeeks: true,
        },
        { returns: "plan", fetchPolicy: "no-cache" }
    )
})
